<template>
  <Layout>
    <SubHeader :title="$t('common.sam_recommend_card_lecture')" slot="sub-header">
      <div slot="sub-header-tab">
        <SubHeaderTab :items="cardLectureSubjects" 
          :selectedId="selectedId"
          @selectedTab="selectedTab" />
      </div>
    </SubHeader>
    <LoadingBounce v-if="busy" slot="body" />
    <div v-else slot="body" class="recommend-card-lecture row">
      <EmptyContent v-if="cardLectures.length === 0"
        :emptyContentText="$t('common.empty_card_lecture')" />
      <div class="col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-2"
        v-else
        v-for="(item, index) in cardLectures" :key="index">
        <ImageCard :cardLecture="item"
          :eventLabel="'video_lectrues.lecture'" />
      </div>

      <PrimeSnackBar v-if="isSnackBar"
        @okSnackBar="showPrime()"
        @closeSnackBar="closeSnackBar()" />

      <InfiniteLoading v-if="cardLectures.length >= 10" @infinite="infiniteHandler" class="w-100">
        <div slot="spinner">
          <LoadingBounce></LoadingBounce>
        </div>
        <span slot="no-results"></span>
        <span slot="no-more"></span>
      </InfiniteLoading>
    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import { CLASSTING_PAY_WEB } from '@/config';

  import { isEmpty } from 'lodash';

  export default {
    name: 'recommend-card-lecture',

    data() {
      return {
        page: 1,
        limit: 10,
        selectedId: 0,
        busy: false,
        orderValue: '-view_count',
        isSnackBar: false,
      };
    },

    components: {
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        filterLecturesSubjects: 'getFilterLecturesSubjects',
        subjectMap: 'getSubjectMap',
        cardLectureSubjects: 'getCardLectureSubjects',
        cardLectures: 'getCardLectures',
        selectedLectureSubjectId: 'getSelectedLectureSubjectId',
        cardLecturePosition: 'getCardLecturePosition',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
      }),
    },

    methods: {
      ...mapActions([
        'fetchSubjects',
        'fetchFilterCardLectures',
        'fetchFilterRecommendCardLectures',
        'setSelectedLectureSubjectId',
      ]),

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okSnackBar() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_card_lectures',
          eventAction: 'click',
        });

        this.isSnackBar = false;
        this.showPrime();
      },

      openSnackBar() {
        this.isSnackBar = true;
      },

      closeSnackBar() {
        this.isSnackBar = false;
      },

      setRecommendCardLectureEventCount(count) {
        return this.$localStorage.set('recommendCardLectureEventCount', count);
      },

      getRecommendCardLectureEventCount() {
        return Number(this.$localStorage.get('recommendCardLectureEventCount') || 0);
      },

      selectedTab(selected) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lectures.subject',
          eventAction: 'click',
          eventValue: selected.id,
        });

        this.selectedId = selected.id;
        this.setSelectedLectureSubjectId(selected.id);
      },

      infiniteHandler($state) {
        const filters = {};
        filters.page = this.cardLecturePosition;
        filters.per_page = this.limit;

        if (this.selectedLectureSubjectId !== 0) {
          filters.subject_id = this.selectedLectureSubjectId;
        }

        this.fetchFilterRecommendCardLectures(filters)
          .then((data) => {
            if (data.length > 0) {
              return $state.loaded();
            }

            return $state.complete();
          });
      },
    },

    beforeMount() {
      this.$route.meta.title = this.$t('common.sam_recommend_card_lecture');
      this.busy = true;
      Promise.resolve()
        .then(() => {
          if (isEmpty(this.subjectMap)) {
            return this.fetchSubjects();
          }
          return true;
        })
        .then(() => {
          if (isEmpty(this.cardLectures)) {
            const filters = {
              page: this.page,
              per_page: this.limit,
            };
            return this.fetchFilterRecommendCardLectures(filters);
          }
          return true;
        })
        .then(() => {
          if (!this.isSubscriptionUser && !this.getRecommendCardLectureEventCount()) {
            return this.setRecommendCardLectureEventCount(1);
          }

          if (!this.isSubscriptionUser && this.getRecommendCardLectureEventCount()) {
            const eventCount = this.getRecommendCardLectureEventCount() + 1;
            return this.setRecommendCardLectureEventCount(eventCount);
          }

          return true;
        })
        .then(() => {
          if (!this.isSubscriptionUser &&
            this.isPrimeSupportCountry &&
            this.getRecommendCardLectureEventCount() >= 15) {
            this.$ga.event({
              eventCategory: 'prime',
              eventLabel: 'snackbar_card_lectures',
              eventAction: 'view',
            });
            this.$localStorage.set('recommendCardLectureEventCount', 0);
            this.openSnackBar();
            return true;
          }
          return true;
        })
        .then(() => {
          this.busy = false;
        });
    },

    watch: {
      selectedLectureSubjectId(selected) {
        if (!this.cardLectures) {
          this.busy = true;
          const filters = {
            page: this.page,
            per_page: this.limit,
            subject_id: selected,
          };
          this.fetchFilterRecommendCardLectures(filters)
            .then(() => {
              this.busy = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  .recommend-card-lecture {
    max-width: 946px;
    margin: 0 auto;
    margin-top: 12px;
  }

</style>


// WEBPACK FOOTER //
// RecommendCardLecture.vue?7de0fcda